import axios from "axios";
const API_URL = process.env.REACT_APP_WORKER_URL || "";
const httpService = {
    async postData(formData: any, token: string) {
        console.log("Sending Request: ", formData);
        try {
            const response = await axios.post(API_URL, {
                ...formData
            }, {
                headers: {
                    "CF-Token": token
                }
            });
            return handleApiResponse(response.data);
        } catch (error: any) {
            if (error.response) {
                console.error(
                    `Error ${error.response.status}: ${error.response.data.message || "Something went wrong."}`
                );
            } else if (error.request) {
                console.error("No response from server. Please check your connection.");
            } else {
                console.error(error.message || "Unexpected error occurred.");
            }
            return { success: false, status: 501, error: error.message };
        }
    },
};

function handleApiResponse(response: any) {
    if (!response || typeof response !== "object") {
        console.error("Invalid response format:", response);
        return;
    }

    console.log("API Response Received:", response);
    // Check overall success
    if (response.success) {
        console.log("Success:", response.message);
    } else {
        console.log("API request failed:", response.message || "Unknown error");
    }

    if (response.tokenResponse) {
        const token = response.tokenResponse;
        if (token.success) {
            console.log("Turnstile validation successful at:", token.challenge_ts);
        } else {
            console.log("Turnstile validation failed:", token["error-codes"]);
        }
    } else {
        console.error("Missing Turnstile token response.");
    }

    if (response.apiResponse) {
        const api = response.apiResponse;
        if (api.success) {
            console.log("API Request was successful:", api.data);
        } else {
            console.log("API Request failed:", api.error || "Unknown API error");
        }
    }
    return response;
}

export default httpService;